import { just } from 'maybeasy';
import { observer } from 'mobx-react';
import Confirmation from './Confirmation';
import LicensingAlertsModal from './LicenseAlerts';
import ParticipantSearch from './ParticipantSearch';
import { shareStore } from './Stores/ShareStore';

function Overlays() {
  switch (shareStore.state.kind) {
    case 'waiting':
    case 'loading':
    case 'ready':
    case 'publishing':
    case 'submitting':
    case 'error':
      return <></>;
    case 'searching':
      return <ParticipantSearch />;
    case 'reviewing':
    case 'refreshing':
      return <LicensingAlertsModal />;
    case 'confirming': {
      const state = shareStore.state;
      // Always show when the invitation is active:
      // - If scheduling is enabled, show the scheduled time
      // - If scheduling is disabled, show "now"
      const scheduledDate = state.scheduleEnabled
        ? shareStore.mergedScheduleDateTime.map(
            (mergedDateTime) =>
              // The merged date holds the typed wall-clock in its local fields;
              // it is not an instant in the selected zone. Render those fields
              // as-is and name the zone, rather than converting the instant,
              // which showed a time nobody had asked for (DVLP-7797).
              `${mergedDateTime.toLocaleString('en-US', {
                weekday: 'short',
                month: 'numeric',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
              })} (${state.scheduleTimezone})`,
          )
        : just(
            new Date().toLocaleString('en-US', {
              weekday: 'short',
              month: 'numeric',
              day: 'numeric',
              year: 'numeric',
              hour: 'numeric',
              minute: '2-digit',
              timeZone: state.scheduleTimezone,
              timeZoneName: 'short',
            }),
          );
      return (
        <Confirmation
          collectionName={state.learningCollectionResource.payload.name}
          scheduledDate={scheduledDate}
        />
      );
    }
  }
}

export default observer(Overlays);
